export default __webpack_public_path__ + "static/media/JobThree5.672679ee.JPG";